
export const SEVEN_ELEVEN_TEXT = '7-Eleven';
export const VIEW_DASHBOARD_TEXT = 'View Dashboard';
export const STORE_TEXT = 'Store';
export const DASHBOARD_TEXT = 'Business';
export const YOUR_STORES_TEXT = 'Your Stores';
export const BUISNESS_GROUP_TEXT = 'Business Group';
export const ORDER_TEXT = 'Orders';
export const DOWNLOAD_REPORT_TEXT = 'Download Report';
export const N_A = 'N/A';
export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
export const CHOOSE_FILES = 'Choose Files';
export const ACCEPTED_FORMATS = 'Accepted Formats:'; 
export const MAX_FILE_SIZE = 'Max File Size: ';
export const SIZE_EXCEEDS_LIMIT = 'File size exceeds the limit.';
export const INVALID_FILE_TYPE = 'Invalid file type.';
export const INVALID_FILE_CONTENT = 'Invalid file content.';
export const MB = 'MB';
export const X = 'X';
export const DOWNLOAD_TEXT = 'Download Report';
